export const hasActiveFeatureFlag = (flagName, site, featureFlags) => {
  const flag = (featureFlags || []).find(ff => ff.name === flagName);

  if (!flag || !site || !site.hasOwnProperty('feature_flags')) {
    return false;
  }

  return site.feature_flags.includes(flag.id);
};
